export default "__VITE_ASSET__28a5b6a8__$_?component__"